import {ReactNode, createContext, useContext} from 'react';

import {useBoolean} from 'shared/web';

interface FocusControlContextType {
  isDisabled: boolean;
  enable: () => void;
  disable: () => void;
}

const FocusControlContext = createContext<FocusControlContextType | undefined>(undefined);

export const FocusControlProvider = ({children}: {children: ReactNode}) => {
  const [isDisabled, disable, enable] = useBoolean(false);

  return (
    <FocusControlContext.Provider
      value={{
        isDisabled,
        enable,
        disable,
      }}
    >
      {children}
    </FocusControlContext.Provider>
  );
};

// eslint-disable-next-line react-refresh/only-export-components
export const useFocusControl = () => {
  const context = useContext(FocusControlContext);
  if (!context) {
    throw new Error('useFocusControl must be used within a FocusControlProvider');
  }
  return context;
};
